import { readonlyRegExp } from './validators';

export const isUserInReadOnlyMode = () => readonlyRegExp.test(location.pathname);
